import { render, staticRenderFns } from "./CustomerListComponent.vue?vue&type=template&id=3ac01a10&"
import script from "./CustomerListComponent.vue?vue&type=script&lang=js&"
export * from "./CustomerListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports